import { Button, useModal } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'

export const SendPaymentReminderButton = () => {
  const { t } = useTranslation()
  const { trackInvoiceView } = useTrackInvoiceView()
  const { open } = useModal(ModalId.SendPaymentReminderModal)

  const handleSendPaymentReminderButtonClick = useCallback(() => {
    trackInvoiceView('Send payment reminder clicked')
    open()
  }, [open, trackInvoiceView])

  return (
    <Button icon="bell" onClick={handleSendPaymentReminderButtonClick} variant="outlined">
      {t('external_invoices.view.send_reminder')}
    </Button>
  )
}
